import React from "react";
import Menu from "../../menu";

const Header2Nav = (props) => {
  const { logged, cp, navSections, segmentMenu, municipios, municipio } = props;
  const selector = logged ? "logged" : "default";
  return (
    <>
      <div className="header2-nav container">
        <div className="menu">
          <div className="section-menu" data-cy="Header links">
            {navSections && navSections[selector] && (
              <Menu
                items={navSections[selector]}
                layout="default"
                location="menu"
              />
            )}
          </div>
          <div className="segment-menu" data-cy="Header secondary links">
            {segmentMenu && segmentMenu[selector] && (
              <Menu
                items={segmentMenu[selector]}
                layout="default"
                location="menu"
              />
            )}
          </div>
        </div>
        <div className="options">
          <Menu
            layout="cp"
            location="menu"
            cp={cp}
            municipios={municipios}
            municipio={municipio}
          />
        </div>
        <style jsx>{`.header2-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  :global(.menu) {
    display: none;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    &::-webkit-scrollbar {
      display: none;
    }
    :global(.menu-item) {
      :global(.text:hover) {
        color: #313235 !important;
        text-decoration: underline;
      }
      :global(.text:active) {
        color: #313235 !important;
        text-decoration: underline;
      }
    }

    :global(.menu-item.selected) {
      :global(.text) {
        color: #313235 !important;
        text-decoration: underline;
      }
    }
  }
  .options {
    display: flex;
    align-items: center;
    :global(button:focus) {
      outline: none;
    }
    :global(.menu-item) {
      display: flex;
      align-items: center;
      gap: 0.25rem;
      :global(.text-gap) {
        :global(.text) {
          font-size: 1rem;
          &:hover {
            color: #313235 !important;
            text-decoration: underline;
            @media (max-width: 768px) {
              color: #019df4 !important;
              text-decoration: none;
            }
          }
        }
      }
      :global(.close) {
        padding-left: 0.5rem;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .header2-nav {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    :global(.menu) {
      display: flex;
      :global(.text) {
        font-size: 1rem;
      }
      :global(.section-menu) {
        display: none;
        gap: 1rem;
        :global(.menu-item) {
          display: inline;
        }
      }
      :global(.segment-menu) {
        display: none;
      }
    }

    .options {
      justify-content: flex-end;
      gap: 0.5rem;
      :global(.menu-item) {
        :global(.text-gap) {
          :global(.text) {
            font-size: 1rem;
            color: #6b6c6f !important;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .header2-nav {
    :global(.menu) {
      :global(.text) {
        font-size: 1rem;
      }
      :global(.section-menu) {
        display: flex;
        :global(.menu-item) {
          display: inline;
        }
      }
    }
    .options {
      :global(.menu-item) {
        :global(.text-gap) {
          :global(.text) {
            font-size: 1rem;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1280px) {
  .header2-nav {
    padding-top: 1rem;
    padding-bottom: 1rem;
    :global(.menu) {
      :global(.text) {
        font-size: 1rem;
      }
      :global(.section-menu) {
        gap: 1.5rem;
        :global(.menu-item) {
          display: inline;
        }
      }
      :global(.segment-menu) {
        display: flex;
        :global(.next-link) {
          display: flex;
          &:last-child {
            display: none;
          }
          &:first-child {
            display: flex;
          }
          &::before {
            display: inline-block;
            padding-right: 0.5rem;
            padding-left: 0.5rem;
            color: #6c757d;
            content: "|";
          }
        }
      }
    }
    .options {
      :global(.menu-item) {
        :global(.text-gap) {
          :global(.text) {
            font-size: 1rem;
          }
        }
      }
    }
  }
}`}</style>
      </div>
    </>
  );
};
export default Header2Nav;
